import React from 'react';

interface CurrencyProps {
  value: number;
  className?: string;
  showFree?: boolean;
}

const SYMBOL = '₹';

export default function Currency({ value, className = '', showFree = true }: CurrencyProps): React.JSX.Element {
  if (value === 0 && showFree) {
    return <span className={className}>Free</span>;
  }
  return (
    <span className={className}>
      {SYMBOL}{value.toLocaleString('en-IN')}
    </span>
  );
}

export function CurrencyCompare({
  price,
  discountPrice,
  className = '',
}: {
  price: number;
  discountPrice?: number;
  className?: string;
}): React.JSX.Element {
  const hasDiscount = discountPrice !== undefined && discountPrice > 0 && discountPrice < price;

  return (
    <div className={`flex items-baseline gap-2 ${className}`}>
      {hasDiscount ? (
        <>
          <Currency value={discountPrice!} className="text-lg font-bold text-slate-900" />
          <Currency value={price} className="text-sm text-slate-400 line-through" />
        </>
      ) : (
        <Currency value={price} className="text-lg font-bold text-slate-900" showFree />
      )}
    </div>
  );
}
